import styled from "styled-components";

export const Container = styled.div`
    background: #CCC;
    color: #FFF;
    padding: 3rem;
    border-radius: 10px;
    width: 100%;
    max-width: 600px;
    margin: 1rem auto;

    display: flex;
    align-items: center;
    justify-content: center;
    transition: filter 0.2s;

    svg{
        font-size: 3.5rem;
    }

    &:hover{
        filter: brightness(0.95);
        cursor: pointer;
    }
`